import {useErrorBoundary} from "preact/hooks";
import {ComponentChildren} from "preact";
import {Page} from "./page";
import {Card} from "./generic/card";
import {WithAPI} from "../api/temperature";
import Icon from "@mdi/react";
import {mdiAlertOutline} from "@mdi/js";
import {AsRoute} from "../app";
import styled from "styled-components";
import {Column, Columns} from "./generic/columns";

type ErrorProps = {
    children: ComponentChildren;
    error?: Error
};

const Error = styled.div`
    margin: 1em;
    padding: 1rem;
    color: #c0392b;
    border-color: #c0392b;
    box-shadow: 0.2rem 0.2rem 0.5rem rgba(192, 57, 43, 0.6);
    text-shadow: 0.1rem 0.1rem 0.1rem rgba(192, 57, 43, 0.12);
    background: #fceae8;
    
    > h1 {
        text-align: left;
    }
`;

export function ComponentError(props: ErrorProps) {
    const [error, resetError] = useErrorBoundary();

    if (error) {
        console.error(error);

        return <Error>
            <h1>Application error!</h1>
            <p>{error.toString()}</p>
            {(error.stack) ?
                <pre>
                    {error.stack}
                </pre>
                : null}
        </Error>;
    }

    return <>{props.children}</>;
}

export function Error404(props: AsRoute) {
    return <Page class="container" showBackButton={true}>
        <Columns>
            <Column>
                <Card title="Not Found." style={{padding: "1rem"}} accent="danger">
                    <p>
                        <Icon path={mdiAlertOutline} size="3em" style={{verticalAlign: "middle", marginRight: ".3em"}} />
                        The requested URL <ins>{location.pathname}</ins> was not found.
                    </p>
                </Card>
            </Column>
        </Columns>
    </Page>;
}
